import React, { useState } from "react";
import IconWizard from "../Images/IconWizard";
import styles from "../Styles/AiAnnouncementAssistant.module.css";
//import { generativeModel } from "../firebaseConfig";

export default function AiAnnouncementAssistant({ onGenerated }) {
  const [showPopup, setShowPopup] = useState(false);
  const [input, setInput] = useState("");
  const [generating, setGenerating] = useState(false);
  const [showActions, setShowActions] = useState(false);

  const handleGenerate = async () => {
    if (!input.trim()) {
      alert("Kirjoita lyhyt kuvaus tiedotteesta ennen generointia.");
      return;
    }
    setGenerating(true);
    try {
      const prompt = `
Luo asunto-osakeyhtiön tiedote seuraavassa muodossa ilman korostusmerkkejä tai listauksia:

Otsikko:
Sisältö:
Kategoria:
Kohderyhmät:

Käyttäjän kuvaus: ${input}

Kategoriavaihtoehdot:
- Tapahtumat ja tilaisuudet
- Ylläpito ja huolto
- Tiedotukset ja uutiset
- Yhtiökokoukset
- Taloustiedotteet
- Säännöt ja ohjeet
- Turvallisuus
- Muut

Kohderyhmävaihtoehdot:
- osakas
- asukas
- hallitus
- isännöitsijä
`;

      //const result = await generativeModel.generateContent(prompt);
      //const text = await result.response.text();
      const text = "teksti";
      const titleMatch = text.match(/Otsikko:\s*(.*)/);
      const contentMatch = text.match(/Sisältö:\s*([\s\S]*?)(?=Kategoria:|$)/);
      const categoryMatch = text.match(/Kategoria:\s*(.*)/);
      const groupMatch = text.match(/Kohderyhmät:\s*(.*)/);

      const generated = {
        title: titleMatch?.[1]?.trim() || "",
        content: contentMatch?.[1]?.trim() || "",
        category: categoryMatch?.[1]?.trim() || "",
        audience: (groupMatch?.[1] || "").includes("osakas")
          ? "owners"
          : "residents_owners",
      };

      onGenerated(generated);
      setShowActions(true);
    } catch (err) {
      console.error("Virhe tekoälyavustajassa:", err);
      alert("Virhe tekoälyavustajan käytössä. Yritä uudelleen.");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={styles.iconButton}
        onClick={() => setShowPopup(true)}
        title="Tekoälyavustaja"
      >
        <IconWizard />
      </button>

      {showPopup && (
        <div className={styles.overlay}>
          <div className={styles.popup}>
            <div className={styles.header}>
              <h3>Tekoälyavustaja</h3>
              <button
                className={styles.closeButton}
                onClick={() => setShowPopup(false)}
              >
                ×
              </button>
            </div>

            <div className={styles.body}>
              <p>
                Kirjoita lyhyt kuvaus siitä, millaisen tiedotteen haluat luoda
                (esim. “Talkoot ensi lauantaina” tai “Vesikatko keskiviikkona klo 9–12”).
              </p>
              <textarea
                className={styles.textarea}
                rows={4}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Kirjoita kuvaus..."
              />
            </div>

            <div className={styles.footer}>
              {!generating && !showActions && (
                <button className={styles.generateButton} onClick={handleGenerate}>
                  Generoi tiedote
                </button>
              )}
              {generating && (
                <button className={styles.generateButton} disabled>
                  <div className={styles.spinner}></div>
                </button>
              )}
              {showActions && !generating && (
                 <>
                <button
                  className={styles.generateButton}
                  onClick={() => setShowPopup(false)}
                >
                  Ok
                </button>
                 <button className={styles.generateButton} onClick={handleGenerate}>
                    Uudelleen generoi
                 </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
